import { spacing } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Box from "../../Box";
export const EdgeToEdgeContainer = styled(Box) `
  margin: 0 calc(${spacing.inset.contentBox} * -1);

  &.compact {
    margin: 0 calc(${spacing.inset.contentBoxCompact} * -1);
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRWRnZVRvRWRnZUNvbnRhaW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0VkZ2VUb0VkZ2VDb250ZW50L3N0eWxlZC9FZGdlVG9FZGdlQ29udGFpbmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUN6RSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEdBQUcsTUFBTSxXQUFXLENBQUM7QUFFNUIsTUFBTSxDQUFDLE1BQU0sbUJBQW1CLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFBO21CQUMzQixPQUFPLENBQUMsS0FBSyxDQUFDLFVBQVU7OztxQkFHdEIsT0FBTyxDQUFDLEtBQUssQ0FBQyxpQkFBaUI7O0NBRW5ELENBQUMifQ==